import {NewsError} from './NewsError.js'

export class SubscribeToNewsletterWithoutEmailError extends NewsError {}
